import React from "react";
import GetDemo from "./get-demo";

class GetDemoController extends React.Component{

    render(){
        return (
            <GetDemo {...this.props}/>
        )
    }

    /*componentWillUnmount(){
        this.props.setIsDemoSuccess(false);
    }*/
}

export default GetDemoController;